module.exports = __webpack_public_path__ + "img/gamelist.c94240d.webp";